const divFormEquipServType = {
  text: 'Upcoming Maturities (Not Required):'
};

export default divFormEquipServType;
